var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendleagueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B3ACA8",
    fillRule: "evenodd",
    d: "M36.836 4.11S12.888 1.507 7.189 0c0 0-.41 6.63 5.59 9.837 2.74 1.48 8.028 2.082 12.933 2.301.082.96.246 1.89.465 2.795-8.685.274-19.207.74-19.207.74s1.48 6.576 8.056 7.864c3.205.63 8.85-.603 13.782-2 .548.958 1.15 1.89 1.808 2.794-7.37 3.425-15.344 7.234-15.344 7.234s3.7 5.672 10.138 4.356c2.768-.548 5.042-2.082 8.631-4.904.85.74 1.726 1.452 2.658 2.11-5.206 4.904-9.124 9.151-9.124 9.151s4.493 3.864 9.48.987c1.59-.905 3.425-2.96 5.206-5.343 2.822-13.81-5.425-33.84-5.425-33.84v.028ZM53.879 37.922c1.78 2.383 3.617 4.438 5.206 5.343 5.014 2.85 9.48-.987 9.48-.987s-3.89-4.247-9.124-9.151a39.006 39.006 0 0 0 2.658-2.11c3.617 2.822 5.89 4.356 8.63 4.904 6.44 1.316 10.139-4.356 10.139-4.356s-7.974-3.809-15.344-7.234a30.352 30.352 0 0 0 1.808-2.795c4.932 1.425 10.577 2.63 13.783 2 6.576-1.287 8.055-7.863 8.055-7.863s-10.522-.466-19.207-.74c.219-.932.383-1.863.466-2.795 4.904-.219 10.192-.822 12.932-2.301C89.39 6.63 88.951 0 88.951 0c-5.672 1.507-29.647 4.11-29.647 4.11s-8.247 20.03-5.425 33.839v-.027Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3ACA8",
    d: "M62.893 41.758c-9.836-5.097-19.673-5.097-29.51 0 5.919 3.863 7.837 7.726 5.755 11.617-1.014 1.836 18.85 1.699 17.892-.246-1.89-3.782.082-7.59 5.863-11.371Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6E1",
    d: "M54.564 46.06H41.576c-7.343 0-13.453-5.672-14.001-13.016L25.3 2.411a2.06 2.06 0 0 1 2.055-2.22h41.428c1.206 0 2.165 1.015 2.055 2.22l-2.274 30.66c-.548 7.344-6.658 13.016-14.001 13.016v-.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.07 18.194V5.946c0-.795-.52-1.452-1.233-1.672H30.013c-.246 0-.465.22-.438.466l2.082 28.003c.11 1.425.521 2.767 1.151 3.973.302.548.96.795 1.535.603 7.973-2.713 13.7-10.248 13.7-19.125h.027ZM67.086 11.371a8.119 8.119 0 0 1-7.097-7.097c0-.082-.11-.082-.11 0a8.119 8.119 0 0 1-7.096 7.097c-.082 0-.082.11 0 .11a8.119 8.119 0 0 1 7.096 7.096c0 .082.11.082.11 0a8.119 8.119 0 0 1 7.097-7.096c.082 0 .082-.11 0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6E1",
    d: "M67.908 50.526H28.232a3.093 3.093 0 0 0-3.096 3.096v4.52c0 1.07.877 1.974 1.973 1.974h41.977a1.982 1.982 0 0 0 1.973-1.973v-4.521a3.093 3.093 0 0 0-3.097-3.096h-.054Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v60H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendleagueIcon);
export default __webpack_public_path__ + "static/media/legendleagueIcon.725a3569d6352062076aa74e57e39b92.svg";
export { ForwardRef as ReactComponent };